import React from "react";
import { CRMSpacing } from "../../../../models/CRMSpacing";
import { CRMColors } from "../../../../models/CRMColors";
import { SpacingColumn } from "../../../BuildingBlocks/SpacingColumn";
import { SpacingRow } from "../../../BuildingBlocks/SpacingRow";
import { Border } from "../../../BuildingBlocks/Border";
import { Padding } from "../../../BuildingBlocks/Padding";
import { MaxWidth } from "../../../BuildingBlocks/MaxWidth";
import { CRMButtonQuaternary } from "../../../CRMButtonQuaternary/CRMButtonQuaternary";
import { TQuoteEmailAttachment } from "../../../../../../domain/codecs/Quote";
import { CRMQuoteAttachment } from "../../../Complex/CRMQuoteAttachment/CRMQuoteAttachment";

export const CRMQuoteAttachmentInserted = (props: {
    index: number;
    quote: TQuoteEmailAttachment;
    onRemove: () => void;
}): JSX.Element => (
    <Border type="bottom" definition={`1px solid ${CRMColors.NEUTRAL_8}`}>
        <Padding type="bottom" spacing={CRMSpacing.LARGE}>
            <SpacingColumn spacing={CRMSpacing.MEDIUM}>
                <SpacingColumn spacing={CRMSpacing.TINY}>
                    <MaxWidth width="450px">
                        <CRMQuoteAttachment
                            tagPrefix={`${props.index}. `}
                            quote={props.quote}
                        />
                    </MaxWidth>
                </SpacingColumn>

                <SpacingRow>
                    <CRMButtonQuaternary
                        label="Remove"
                        icon="delete"
                        onClick={props.onRemove}
                    />
                </SpacingRow>
            </SpacingColumn>
        </Padding>
    </Border>
);
